<template>
    <v-card tile elevation="0">
        <v-card-text >
            <v-layout align-center>
                <v-flex xs12 sm2>옵션명 개수</v-flex>
                <v-flex grow-shrink-0>
                    <v-select v-model="additionCount" :items="additionCountItems" item-text="text" item-value="value" dense outlined hide-details></v-select>
                </v-flex>
            </v-layout>
        </v-card-text>

        <v-divider />

        <v-card-text>
            <v-layout align-center>
                <v-flex xs12 sm2>옵션입력</v-flex>
                <v-flex xs12 sm10>
                    <v-layout>
                        <v-flex xs10 class="px-1">
                            <v-layout>
                                <v-flex xs4 class="text-center">추가상품명</v-flex>
                                <v-flex xs4 class="text-center">추가상품값</v-flex>
                                <v-flex xs4 class="text-center">추가상품가</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs2>
                        </v-flex>
                    </v-layout>
                    <v-divider class="mt-2"/>
                    <v-layout v-for="(i, index) in additionCount" :key="index" class="mt-2 mx-n1">
                        <v-flex xs10 class="px-1">
                            <v-layout class="mx-n1">
                                <v-flex xs4 class="px-1">
                                    <v-text-field v-model="additionGroups[index].name" dense outlined hide-details></v-text-field>
                                </v-flex>
                                <v-flex xs4 class="px-1">
                                    <v-text-field v-model="additionGroups[index].value" dense outlined hide-details></v-text-field>
                                </v-flex>
                                <v-flex xs4 class="px-1">
                                    <v-text-field v-model="additionGroups[index].salePrice" dense outlined hide-details @input="additionGroups[index].salePrice = additionGroups[index].salePrice.replace(/[^0-9,]/,'')"></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs2 class="px-1">
                            <v-btn v-if="1 < additionCount" color="white" width="36" class="px-1 mr-1 primary--text" style="min-width: auto" @click="additionCount--"><v-icon>mdi-minus</v-icon></v-btn>
                        </v-flex>
                    </v-layout>
                    <v-layout class="mt-2 mx-n1">
                        <v-flex class="px-1">
                            <v-btn width="100%" color="primary" dark @click="generate()">옵션목록으로 적용<v-icon small class="ml-2">mdi-chevron-down</v-icon></v-btn>
                        </v-flex>
                        <v-flex class="px-1" xs2>
                            <v-btn v-if="additionCount < additionCountItems.length" width="36" color="primary" class="px-1" style="min-width: auto" @click="additionCount++"><v-icon>mdi-plus</v-icon></v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-card-text>

        <v-divider class="mt-4"></v-divider>

        <v-card-text>
            <v-layout class="mt-4">
                <v-flex xs2>옵션목록</v-flex>
                <v-flex xs10>
                    <v-layout>
                        <v-spacer></v-spacer>
                        <v-flex class="px-1">
                            <v-select v-model="header.operator" :items="operatorItems" label="연산자" persistent-placeholder outlined dense hide-details></v-select>
                        </v-flex>
                        <v-flex class="px-1">
                            <v-text-field v-model="header.salePrice" label="추가상품가" persistent-placeholder outlined dense hide-details @input="header.salePrice = header.salePrice.replace(/[^0-9]/,'')"></v-text-field>
                        </v-flex>
                        <v-flex class="px-1">
                            <v-text-field v-model="header.stock" label="재고수량" persistent-placeholder outlined dense hide-details @input="header.stock = header.stock.replace(/[^0-9]/,'')"></v-text-field>
                        </v-flex>
                        <v-flex xs2 class="px-1">
                            <v-btn color="secondary" small height="40" @click="batch">선택목록 일괄수정</v-btn>
                        </v-flex>
                    </v-layout>

                    <v-divider class="mt-2"/>

                    <v-data-table v-model="selected" :headers="additionalProductsHeaders" :items="additionalProducts.filter((addition) => !addition.isDeleted)" item-key="additionalValue" show-select>
                        <v-text-field slot="item.salePrice" slot-scope="{item}" v-model="item.salePrice" dense hide-details class="price" />
                        <v-text-field slot="item.stock" slot-scope="{item}" v-model="item.stock" dense hide-details class="price" />
                        
                        <v-icon slot="item.actions" slot-scope="{item}" small @click="remove(item)">mdi-delete</v-icon>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: {
        value: { type: [Object, Array], default(){ return []; } }
    },
    data() {
        return {
            selected: [],
            additionalProducts: this.$props.value || [],
            additionalProductsHeaders: [
                { text: "추가상품명", align: "center", sortable: false, width: 140, value: "additionalName" },
                { text: "추가상품값", align: "center", width: 140, value: "additionalValue" },
                { text: "추가상품가", align: "center", width: 140, value: "salePrice" },
                { text: "재고수량", align: "center", width: 140, value: "stock" },
                { text: "actions", align: "center", width: 100, sortable: false, value: "actions" }
            ],

            additionGroups: [{ name: '', value: '', price: '', companyPrice: '' }],

            header: {
                operator: 1,
                salePrice: 0,
                stock: 0,
            },

            additionCount: 1,
            additionCountItems: [
                { text: "1개", value: 1 },
                { text: "2개", value: 2 },
                { text: "3개", value: 3 },
                { text: "4개", value: 4 },
                { text: "5개", value: 5 }
            ],

            operatorItems: [
                { text: '+', value: 1 },
                { text: '-', value: -1 }
            ],

            enabledItems: [
                { text: 'Y', value: true },
                { text: 'N', value: false }
            ]
        };
    },
    methods: {
        
        remove(additionalProduct){
            additionalProduct._id ? this.$set(additionalProduct, "isDeleted", true) : this.additionalProducts.splice(this.additionalProducts.indexOf(additionalProduct), 1);
        },

        generate(){
            while(this.additionalProducts.some(additionalProduct => !additionalProduct.isDeleted)){
                this.remove(this.additionalProducts.find(additionalProduct => !additionalProduct.isDeleted));
            }
            this.selected = [];

            for(var count = 0; count < this.additionCount; count++){
                var name = this.additionGroups[count].name;
                var values = this.additionGroups[count].value.split(',');
                var salePrices = this.additionGroups[count].salePrice.split(',');


                values.forEach((value, index) => {
                    if(!name.trim() || !value.trim()) return;

                    this.additionalProducts.push({
                        type: "addition",
                        additionalName: name.trim(),
                        additionalValue: value.trim(),
                        salePrice: +salePrices[index] || 0,
                        stock: 0,
                    });
                });
            }
        },

        batch(){
            for(var additionalProduct of this.selected){
                additionalProduct.salePrice = +additionalProduct.salePrice + parseInt(+this.header.salePrice || 0) * this.header.operator;
                additionalProduct.stock = +additionalProduct.stock + parseInt(+this.header.stock || 0) * this.header.operator;
            }
        }
    },
    watch: {
        value(){
            this.additionalProducts = this.value || [];
        },
        additionCount(){
            this.additionGroups.splice(this.additionCount, this.additionGroups.length - this.additionCount);
            for(var count = 0; count < this.additionCount; count++){
                if(!this.additionGroups[count]) this.$set(this.additionGroups, count, { name: '', value: '', salePrice: '' });
            }
        },
        additionalProducts: {
            deep: true,
            handler(){
                this.$emit("input", this.additionalProducts);
            }
        }
    }
}
</script>

<style>
.shop-product-additionalProducts .price input[type=text] { text-align: center; }
</style>
